<template>
  <v-select
    class="searchable-select"
    :value="value"
    :options="options"
    :filterable="false"
    :loading="loading"
    :disabled="disabled"
    :placeholder="placeholder"
    :multiple="multiple"
    label="text"
    @search="onSearch"
    @input="$emit('input', $event)"
  >
    <template #no-options>
      <span class="text-muted">No results found.</span>
    </template>
  </v-select>
</template>

<script>
const SEARCH_DEBOUNCE_MS = 350;

/**
 * Select dengan pencarian ke server.
 *
 * `fetcher` adalah fungsi `(query) => Promise<[{ value, text }]>` yang
 * melakukan request ke backend (mis. dengan query param `finds[...]`).
 * v-model menyimpan objek opsi terpilih ({ value, text }) atau null, jadi
 * label tetap tampil walau opsi hasil pencarian sudah berganti.
 */
export default {
  name: 'SearchableSelect',
  props: {
    value: {
      type: [Object, Array],
      default: null,
    },
    fetcher: {
      type: Function,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      loading: false,
      searchTimer: null,
    };
  },
  mounted() {
    this.runSearch('');
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    onSearch(query) {
      clearTimeout(this.searchTimer);
      this.loading = true;
      this.searchTimer = setTimeout(() => this.runSearch(query), SEARCH_DEBOUNCE_MS);
    },
    async runSearch(query) {
      this.loading = true;
      try {
        this.options = await this.fetcher(query);
      } catch (error) {
        this.options = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.searchable-select {
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
}
</style>
